import { createContext, useContext } from "react"
import { Toaster, toaster } from "@hydrologiq/shared/chakra/Toaster"
import { CreateToasterReturn } from "@chakra-ui/react"

const ToastContext = createContext<CreateToasterReturn>(toaster)

export const useToaster = () => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error("useToaster must be used within ToastProvider")
  }
  return context
}

export function ToastProvider({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <ToastContext.Provider value={toaster}>
      {children}
      <Toaster />
    </ToastContext.Provider>
  )
}
